import type { ConfigType } from '@plone/registry';
import installSettings from './config/settings';
import { Icon } from '@plone/volto/components';
import paintBucketSVG from '@plone/volto/icons/paint.svg';
import heroSVG from '@plone/volto/icons/hero.svg';
import cardsSVG from '@plone/volto/icons/cards.svg';
import iconSVG from '@plone/volto/icons/select-all.svg';
import sliderSVG from '@plone/volto/icons/slider.svg';
import { Edit as CustomHeroEdit, View as CustomHeroView} from './components/Blocks/CustomHero';
import { Edit as ButtonRowEdit, View as ButtonRowView} from './components/Blocks/ButtonRow';
import { Edit as MultiCardEdit, View as MultiCardView } from './components/Blocks/MultiCardBlock';
import { Edit as IconLinkRowEdit, View as IconLinkRowView} from './components/Blocks/IconLinkRow';
import { Edit as EmblaCarouselEdit, View as EmblaCarouselView} from './components/Blocks/EmblaCarousel';
//import { Edit as EmblaRatingsEdit, View as EmblaRatingsView } from './components/Blocks/EmblaRatings';
import blockThemes from './config/blockThemes';
import { injectEditThemeStyles } from './utils/injectEditThemeStyles';
export {
  MASTER_COLOR_LIST,
  getColorChoices,
  isColorDark,
} from "./config/colors";

function applyConfig(config: ConfigType) {
  installSettings(config);

    config.blocks.themes = blockThemes;

    if (typeof window !== 'undefined') {
      if (document.readyState === 'loading') {
        document.addEventListener(
          'DOMContentLoaded',
          () => injectEditThemeStyles(blockThemes),
          { once: true },
        );
      } else {
        injectEditThemeStyles(blockThemes);
      }
    }
  
    //Enable autoplay on Slider
    config.blocks.blocksConfig.slider.enableAutoPlay = true;
  
    //Adding custom colours and block styles to Slate editor
    config.settings.slate.styleMenu.inlineStyles = [
      ...(config.settings.slate.styleMenu?.inlineStyles || []),
      {
        cssClass: 'text-red',
        label: 'Red Text',
        icon: () => <Icon name={paintBucketSVG} size="18px" color="red" />,
      },
      {
        cssClass: 'text-green',
        label: 'Green Text',
        icon: () => <Icon name={paintBucketSVG} size="18px" color="green" />,
      },
      {
        cssClass: 'text-blue',
        label: 'Blue Text',
        icon: () => <Icon name={paintBucketSVG} size="18px" color="blue" />,
      },
    ];
    config.settings.slate.styleMenu.blockStyles = [
      ...(config.settings.slate.styleMenu?.blockStyles || []),
      {
        cssClass: 'highlight-block',
        label: 'Highlighted Block',
        nodeType: 'paragraph', // Ensures it only applies to paragraph blocks
        icon: () => (
          <div
            style={{
              backgroundColor: 'yellow',
              width: '18px',
              height: '18px',
              borderRadius: '3px',
            }}
          />
        ),
      },
    ];
  
    //CustomHero
    config.blocks.blocksConfig.customHero = {
      id: 'customHero',
      title: 'Hero Block',
      icon: heroSVG,
      group: 'common',
      view: CustomHeroView,
      edit: CustomHeroEdit,
      restricted: false,
      mostUsed: true,
      sidebarTab: 1,
    };
  
    //ButtonRow
    config.blocks.blocksConfig.buttonRow = {
      id: 'buttonRow',
      title: 'Button Row',
      icon: cardsSVG,
      group: 'common',
      view: ButtonRowView,
      edit: ButtonRowEdit,
      restricted: false,
      mostUsed: true,
      sidebarTab: 1,
    };
  
    //IconLinkRow
    config.blocks.blocksConfig.iconLinkRow = {
      id: 'iconLinkRow',
      title: 'Icon Link Row',
      icon: iconSVG,
      group: 'common',
      view: IconLinkRowView,
      edit: IconLinkRowEdit,
      restricted: false,
      mostUsed: true,
      sidebarTab: 1,
    };
  
    //Multicard Block
    config.blocks.blocksConfig.multiCard = {
      id: 'multiCard',
      title: 'Multi Card',
      icon: cardsSVG,
      group: 'common',
      view: MultiCardView,
      edit: MultiCardEdit,
      restricted: false,
      mostUsed: true,
      sidebarTab: 1,
    };
  
    //Embla Carousel
    config.blocks.blocksConfig.EmblaCarousel = {
      id: 'EmblaCarousel',
      title: 'Embla Carousel',
      icon: sliderSVG,
      group: 'common',
      view: EmblaCarouselView,
      edit: EmblaCarouselEdit,
      restricted: false,
      mostUsed: true,
      sidebarTab: 1,
    };
  
    //Embla Ratings
    /*config.blocks.blocksConfig.EmblaRatings = {
      id: 'EmblaRatings',
      title: 'Embla Ratings',
      icon: sliderSVG,
      group: 'common',
      view: EmblaRatingsView,
      edit: EmblaRatingsEdit,
      restricted: false,
      mostUsed: true,
      sidebarTab: 1,
    };*/

  return config;
}

export default applyConfig;
